import actionTypes from '../constants/action-types';

const switchColorPalette = (paletteVariables) => ({
  type: actionTypes.SWITCH_COLOR_PALETTE,
  payload: {
    paletteVariables,
  },
});

export default switchColorPalette;
